import { createRouter, createWebHistory } from "vue-router";
import store from "../store";

import LoginPage from "../views/LoginPage.vue";
import AdminLayout from "../views/admin/AdminLayout.vue";
import AdminDashboard from "../views/admin/AdminDashboard.vue";
import AdminPermanentCustomers from "../views/admin/AdminPermanentCustomers.vue";
import AdminOperators from "../views/admin/AdminOperators.vue";
import AdminSettings from "../views/admin/AdminSettings.vue";
import AdminReports from "../views/admin/AdminReports.vue";
import AdminLogs from "../views/admin/AdminLogs.vue";

import OperatorLayout from "../views/operator/OperatorLayout.vue";
import OperatorEntryExit from "../views/operator/OperatorEntryExit.vue";
import OperatorActive from "../views/operator/OperatorActive.vue";
import OperatorHistory from "../views/operator/OperatorHistory.vue";

const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", name: "login", component: LoginPage, meta: { public: true } },

  {
    path: "/admin",
    component: AdminLayout,
    meta: { role: "admin" },
    children: [
      { path: "", redirect: "/admin/dashboard" },
      { path: "dashboard", component: AdminDashboard },
      { path: "permanent-customers", component: AdminPermanentCustomers },
      { path: "operators", component: AdminOperators },
      { path: "settings", component: AdminSettings },
      { path: "reports", component: AdminReports },
      { path: "logs", component: AdminLogs },
    ],
  },

  {
    path: "/operator",
    component: OperatorLayout,
    meta: { role: "operator" },
    children: [
      { path: "", redirect: "/operator/entry-exit" },
      { path: "entry-exit", component: OperatorEntryExit },
      { path: "active", component: OperatorActive },
      { path: "history", component: OperatorHistory },
    ],
  },

  { path: "/:pathMatch(.*)*", redirect: "/login" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  const isPublic = Boolean(to.meta?.public);
  const isAuthed = store.getters.isAuthed;
  const role = store.getters.role;

  if (isPublic) {
    if (isAuthed) return role === "admin" ? "/admin/dashboard" : "/operator/entry-exit";
    return true;
  }

  if (!isAuthed) return "/login";

  const requiredRole = to.meta?.role;
  if (requiredRole && role !== requiredRole) {
    return role === "admin" ? "/admin/dashboard" : "/operator/entry-exit";
  }

  return true;
});

export default router;
